// extracted by mini-css-extract-plugin
export default {"hed":"rm","blend":"sm","resultsBox":"tm","left":"um","right":"vm","center":"wm","base":"xm","milk":"ym","text":"zm","hyroxresult":"Am","margin":"Bm"};
    if(module.hot) {
      // 1714422952483
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  